import React, {FormEvent, memo, ReactNode, useCallback, useEffect, useRef, useState} from 'react';
import {useDebounce} from '../../../hooks/debounce';
import {CustomizedRangeRawComponent} from "../RangeRawComponent"
import {ColumnProps} from '../../Column';

type Props = {
    name: string
    value: number
    onChange: (value: number) => void
    activeImage: string
    passiveImage: string
    columnProps?: Partial<ColumnProps>
    children?: ReactNode
    minValue: number
    maxValue: number
    stepValue: number
    valueType: string
}

export const CustomizedRange = memo(function CustomizedRange(props: Props) {
    const {name,columnProps , value: valueProp, onChange: onChangeProp, children, activeImage, passiveImage, minValue, maxValue, stepValue, valueType} = props;

    const [tempValue, setTempValue] = useState(0);
    const [value, setValue] = useState(valueProp);
    const timeoutRef = useRef<number>();

    const onChangeCallback = useDebounce(onChangeProp, 200);

    const click = useCallback(() => {
        let newValue
        if (value > 10) {
            setTempValue(value)
            newValue = minValue
        } else if (tempValue > 10) {
            newValue = tempValue
        } else {
            newValue = maxValue
        }

        setValue(newValue)
        onChangeCallback(newValue)
    }, [tempValue, value, onChangeCallback, maxValue, minValue])

    const onChange = useCallback((e: FormEvent<HTMLInputElement>) => {
        // @ts-ignore
        const newValue = e.target.valueAsNumber;
        if (newValue !== value) {
            setValue(newValue);
            onChangeCallback(newValue);
        }
    }, [onChangeCallback, value]);

    useEffect(() => {
        setValue(valueProp);
    }, [valueProp]);

    useEffect(() => {
        timeoutRef.current = setTimeout(() => {
            if (value !== valueProp) {
                setValue(valueProp);
            }
        }, 2000);

        return () => clearTimeout(timeoutRef.current);
    }, [value, valueProp]);

    return (
        <CustomizedRangeRawComponent
            columnProps={columnProps}
            name={name}
            click={click}
            value={value}
            onChange={onChange}
            activeImage={activeImage}
            passiveImage={passiveImage}
            minValue={minValue}
            maxValue={maxValue}
            stepValue={stepValue}
            valueType={valueType}
        >
            {children}
        </CustomizedRangeRawComponent>
    )
});
